@import "../../globalStyles/commons";


:host {
  display: inline-block;
}

.link {
  height: 100%;
  border-radius: var(--border-radius);
  display: flex;
  align-items: center;
  flex-direction: row;
  cursor: pointer;
  text-decoration: var(--link-decoration, none);

  color: var(--link-color, var(--link-01));

  &:hover {
    color: var(--link-color-hover, var(--hover-primary-text));
    text-decoration: var(--link-decoration-hover, underline);
  }

  &:visited {
    color: var(--link-color-visited, var(--visited-link));
  }

  &.active {
    color: var(--link-color-active, var(--text-primary));
  }


}

:host(.no-style) .link {
  color: inherit !important;
  text-decoration: none !important;
}

:host(.no-decoration) .link {
  text-decoration: none !important;
}

:host(.inline) .link {
  text-decoration: var(--link-decoration, underline);
}

.link.has-focus:not(.active) {
  text-decoration: none;
  @include focus-ring();
}
